<template>
  <div class="pt-8 inline-block">
    <MultiselectTags
      v-model="multiselectValue"
      :label="$t('region')"
      :options="regions"
      :can-deselect="false"
      :can-clear="true"
      :searchable="true"
      class="min-w-[20rem]"
      slim
    />
    <p v-if="multiselectValue.length > 0 && multiselectValue.length < regions.length">
      (+ {{ $t('moreRegions') }})
    </p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import MultiselectTags from '@utils/MultiselectTags.vue';

interface SelectChoice {
  label: string;
  value: string;
}

interface Props {
  campaignGroup?: { regions?: { id: string; name: string }[] } | null;
  // if used for pointrewards
  regionsList?: { id: string; name: string }[];
  modelValue: { regions: string[] | null };
}

const props = defineProps<Props>();
const emits = defineEmits(['update:model-value']);

const regions = computed<SelectChoice[]>(() => {
  const regionChoices: SelectChoice[] = [];
  if (props.regionsList && props.regionsList.length > 0) {
    props.regionsList.forEach((r) => {
      regionChoices.push({
        label: r.name,
        value: r.id,
      });
    });
  } else if (props.campaignGroup && props.campaignGroup.regions) {
    props.campaignGroup.regions.forEach((r) => {
      if (!regionChoices.find(c => c.value === r.id)) {
        regionChoices.push({
          label: r.name,
          value: r.id,
        });
      }
    });
  }
  return regionChoices;
});

const multiselectValue = computed({
  get: () => {
    const output: SelectChoice[] = [];
    if (props.modelValue?.regions) {
      props.modelValue.regions.forEach((r) => {
        const obj = regions.value.find(choice => choice.value === r);
        if (obj) output.push(obj);
      });
    }
    return output;
  },
  set: (value: SelectChoice[]) => {
    emits('update:model-value', { regions: value.map(v => v.value) });
  },
});
</script>
